import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";
import { model as lolSummonerModel } from "@/game-lol/models/lol-summoner.mjs";

export const model = {
  ...(lolSummonerModel as unknown as Omit<typeof lolSummonerModel, "ranks">),
} satisfies ModelDefinition;

delete model["ranks"];

const LolSummonerWoRanksModel = createModel({
  data: { leagueProfile: model },
}).transform(model, (data) => data.data.leagueProfile);

export type LolSummonerWoRanks = FromModel<typeof LolSummonerWoRanksModel>;

// Note: do not actually use this model directly, this mainly exists
// for GraphQL querying.
export default LolSummonerWoRanksModel;
